<template>
	<article>
		<section class="xbed-sub-title">
			<span>对账收款导入记录</span>
		</section>

		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>报表</BreadcrumbItem>
				<BreadcrumbItem>订单统计报表</BreadcrumbItem>
				<BreadcrumbItem>导入记录</BreadcrumbItem>
			</Breadcrumb>
		</section>

		<section style="margin-top:20px">
			<Form v-model="importForm" inline>
				<FormItem label="导入日期：" prop="importDate" :label-width="100">
					<DatePicker v-model="importForm.importDate" @on-change="dateRange => {changeDate(dateRange, 'importDate')}" :clearable="false" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 250px"></DatePicker>
				</FormItem>
				<FormItem label="类型：" prop="type" :label-width="80">
					<Select v-model="importForm.type" @on-change="changeDownloadBtn(false)" filterable>
						<Option :value="0">全部</Option>
						<Option :value="1">对账表</Option>
						<Option :value="2">收款表</Option>
					</Select>
				</FormItem>
				<FormItem prop="filter">
					<Button type="primary" @click="queryFilterResult">筛选</Button>
				</FormItem>
				<FormItem v-show="downloadBtnDisplay" prop="download">
					<Button type="primary" @click="downloadFilterResult" :loading="exportBtn.downloadFilterResult">下载筛选结果</Button>
				</FormItem>
			</Form>
			<Table stripe :loading="checkResult.loading" ref="orderReportTable" :columns="column" :data="checkResult.data"></Table>
			<div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement="top" :total="checkResult.count" :current="checkResult.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
			</div>
		</section>

	</article>
</template>

<script>
import Moment from "moment";
import Config from "../../config"
import Utils from "../../utils";
import API from "../../api";
import {STORE_KEY} from "../../constants"

export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	async mounted() {
		this.$Notice.config( {
			top: 200
		} );
		this.resetBundle();
		this.query( this.checkResult );
	},
	data() {
		let beforeDate = new Date();
		beforeDate.setDate( beforeDate.getDate() - 59 );
		let defaultDate = [
			Moment().subtract( 59, 'days' ).format( 'YYYY-MM-DD' ),
			Moment().format( 'YYYY-MM-DD' )
		];
		return {
			exportBtn: {
				downloadFilterResult: false,
				downloadMatchResult: false
			},
			column: [
				{
					title: "ID",
					key: "id",
					align: "center",
					width: 100
				},
				{
					title: "类型",
					key: "type",
					align: "center",
					width: 100
				},
				{
					title: "结账月份",
					key: "settleDate",
					align: "center",
					width: 100,
					render: ( h, params ) => {
						let settleDate = params.row.settleDate ? Moment( params.row.settleDate ).format( 'YYYY-MM' ) : '-';
						return h( "div", {}, settleDate );
					}
				},
				{
					title: "导入数据量",
					key: "importNumber",
					width: 150,
					align: "center"
				},
				{
					title: "无效数据量",
					key: "invalidNumber",
					width: 150,
					align: "center"
				},
				{
					title: "匹配数据量",
					key: "matchedNumber",
					width: 150,
					align: "center"
				},
				{
					title: "匹配成功量",
					key: "matchSuccessNumber",
					width: 150,
					align: "center"
				},
				{
					title: "匹配异常量",
					key: "matchFailedNumber",
					width: 150,
					align: "center"
				},
				{
					title: "导入时间",
					key: "importTime",
					width: 200,
					align: "center",
					render: ( h, params ) => {
						let importTime = Moment( params.row.importTime ).format( 'YYYY-MM-DD HH:mm:ss' );
						return h( "div", {}, importTime );
					}
				},
				{
					title: "操作人",
					key: "operator",
					width: 140,
					align: "center"
				},
				{
					title: "下载",
					width: 152,
					align: "center",
					render: ( h, params ) => {
						return h( "div", [
							h(
								"Button",
								{
									props: {
										type: "primary",
										size: "small",
										loading: this.exportBtn.downloadMatchResult,
									},
									style: {
										marginRight: "10px"
									},
									on: {
										click: () => {
											this.downloadMatchResult( params.row.id, params.row.type );
										}
									}
								},
								"下载匹配结果"
							)
						] );
					}
				}
			],
			importForm: {
				importDate: defaultDate,
				type: 0
			},
			checkResult: {},
			downloadBtnDisplay: false
		};
	},
	methods: {
		changeDate( dateRange, datePicker ) {
			this.changeDownloadBtn( false );
			if ( !dateRange[0] ) {
				this.importForm[datePicker] = [];
			}
		},
		changePage( pageIndex ) {
			this.checkResult.page = pageIndex;
			this.query( this.checkResult );
		},
		changePageSize( pageSize ) {
			this.checkResult.page = 1;
			this.checkResult.pageSize = pageSize;
			this.query( this.checkResult );
		},
		async query( checkResult ) {
			checkResult.loading = true;
			// TODO: 接接口
			let resp = ( await this.listCheckResult( checkResult, this.token, this.env ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}
			this.changeDownloadBtn( true );
			checkResult.data = resp.result;
			checkResult.count = resp.count;
			checkResult.loading = false;
		},
		listCheckResult( checkResult, token, env ) {
			let params = {
				startDate: Moment( this.importForm.importDate[0] ).format( 'YYYY-MM-DD' ),
				endDate: Moment( this.importForm.importDate[1] ).format( 'YYYY-MM-DD' ),
				page: checkResult.page,
				size: checkResult.pageSize,
			};
			this.importForm.type !== 0 ? params.type = this.importForm.type : '';
			return API.omsAPI[env].order.queryListCheckResult( params, token );
		},
		queryFilterResult() {
			if ( this.importForm.importDate.join( '' ).length == 0 ) {
				this.$Notice.error( {
					title: "筛选失败",
					desc: "请选择导入日期"
				} );
				return;
			}
			this.checkResult.page = 1;
			this.query( this.checkResult );
		},
		downloadFilterResult() {
			if ( !this.checkHasPermission( 'check_downloadAllCheckResult' ) ) {
				return;
			}
			if ( this.importForm.type == 0 ) {
				this.$Notice.error( {
					title: "下载失败",
					desc: "请先选择类型"
				} );
				return;
			} else if ( this.importForm.importDate.join( '' ).length == 0 ) {
				this.$Notice.error( {
					title: "下载失败",
					desc: "请选择导入日期"
				} );
				return;
			}

			let url = `${ Config[this.env].accountUrl }check/downloadAllCheckResult` +
				"?startDate=" + ( Moment( this.importForm.importDate[0] ).format( 'YYYY-MM-DD' ) ) +
				"&endDate=" + Moment( this.importForm.importDate[1] ).format( 'YYYY-MM-DD' ) +
				"&type=" + this.importForm.type;

			// window.open(url ,"_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this.exportBtn, "downloadFilterResult")
		},
		downloadMatchResult( id, type ) {
			if ( !this.checkHasPermission( 'check_downloadSingleCheckResult' ) ) {
				return;
			}
			let typeState = type !== "收款表" ? 1 : 2;
			let url = `${ Config[this.env].accountUrl }check/downloadSingleCheckResult?id=${ id }&type=${ typeState }`

			// window.open(url ,"_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this.exportBtn, "downloadMatchResult")
		},
		changeDownloadBtn( state = false ) {
			this.downloadBtnDisplay = state;
		},
		checkHasPermission( name ) {
			if ( !Utils.hasPermission( name ) ) {
				this.$Notice.error( {
					title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
				} );

				return false;
			}
			return true;
		},
		resetBundle() {
			this.checkResult = {
				count: 0,
				pageCount: 0,
				page: 1,
				pageSize: 10,
				loading: false,
				data: []
			};
		},
		refreshTable() {
			this.resetBundle();
			this.query( this.checkResult );
		}
	}
};
</script>

<style lang="scss" scoped>
.add-wrapper {
	margin-top: 20px;
}

.tabs {
	margin-top: 20px;
}

.table-wrapper {
	margin-top: 20px;
}

table.detail-table {
	$black_border: 1px solid #000;
	th,
	td {
		border-left: $black_border;
		border-top: $black_border;
		padding: 5px;
	}
	margin-top: 20px;
	width: 100%;
	border-right: $black_border;
	border-bottom: $black_border;
	text-align: center;
}

.text-align-right {
	text-align: right;
}

.text-align-center {
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/report/import-records.vue